import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import CameraDetails from '../CameraDetails'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FixedSizeList as List } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import sortBy from 'ramda/src/sortBy'
import isEmpty from 'ramda/src/isEmpty'

const NoMatch = ({ classes, category }) =>
  <div className={classes.NoMatch}>
    {
      category === 'recents'
      ? 'No recent models'
      : 'No favorite models'
    }
  </div>

const ListItem = ({ data, index, style }) => {
  const { cameras, classes, initialCamera, updateCameraList, favoriteModels, recentModels } = data
  const camera = cameras[index]

  return (
    <div
      onClick={_ => updateCameraList(camera)}
      className={initialCamera && camera.model === initialCamera.model ? classes.selected : (index % 2 === 0 ? classes.listItemOdd : classes.listItemEven)}
      style={style}
    >
      <span className={classes.cameraText}>{camera.text}</span>
      {
        recentModels.includes(camera.id) &&
        <FontAwesomeIcon icon={'history'} className={classes.clock} />
      }
      { favoriteModels.includes(camera.id) &&
        <FontAwesomeIcon icon='star' className={classes.star} />
      }
    </div>
  )
}

const cameraData = ({ cameras, initialCamera, classes, updateCameraList, favoriteModels, recentModels }) => ({
  cameras: sortBy(c => recentModels.includes(c.id) ? (favoriteModels.includes(c.id) ? 0 : 1) : (favoriteModels.includes(c.id) ? 2 : 3))(cameras),
  initialCamera,
  classes,
  updateCameraList,
  favoriteModels,
  recentModels
})

class CameraList extends React.Component {
  render() {
    const { selectedCamera, initialCamera, initialAoV, cameras, updateCameraList, close, applySingle, classes } = this.props

    if (selectedCamera) return <CameraDetails { ...{ selectedCamera, initialCamera, initialAoV, updateCameraList, close, applySingle } } />

    return (
      <div className={classes.CameraList}>
        {
          isEmpty(cameras)
          ? <div className={classes.list}>
              <NoMatch {...this.props} />
            </div>
          : <AutoSizer disableWidth>
              {({ height }) => (
                <List
                  height={height}
                  itemCount={cameras.length}
                  itemData={cameraData(this.props)}
                  itemSize={36}
                  width={'100%'}
                  className={classes.list}
                >
                  { ListItem }
                </List>
              )}
            </AutoSizer>
        }
      </div>
    )
  }
}

export default (injectSheet(style)(CameraList))



// WEBPACK FOOTER //
// ./src/components/BottomBar/ModelSelector/CameraList/index.js